import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { useTheme } from '@material-ui/core/styles';
import { ConsumerReport } from '../../../types';

type CELL = {
  name: string;
  label?: string;
  render?: (data: ConsumerReport, cell: CELL) => JSX.Element;
  coloredBackground?: boolean,
  coloredText?: boolean,
  fontWeight?: boolean,
}

const CELLS: CELL[] = [
  { name: 'id' },
  { name: 'firstName', label: 'First Name' },
  { name: 'lastName', label: 'Last Name' },
  // { name: 'phone', label: 'Phone' },
  { name: 'email', label: 'Email' },
  {
    name: 'country',
    label: 'Country',
    render: (data): JSX.Element => <>{data.country?.name ?? '—'}</>,
  },
  // { name: 'city', label: 'City' },
  {
    name: 'model',
    label: 'Model',
    render: (data): JSX.Element => <>{data.model?.name ?? '—'}</>,
  },
  {
    name: 'datePurchase',
    label: 'Date of Purchase',
    render: (data): JSX.Element => {
      const date = new Date(data.datePurchase);
      const formattedDate = `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
      return <>{formattedDate}</>;
    },
  },
  {
    name: 'createdAt',
    label: 'Date of Registration',
    render: (data): JSX.Element => {
      const date = new Date(data.createdAt);
      const formattedDate = `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
      return <>{formattedDate}</>;
    },
  },
];

type ConsumerItemProps = {
  data: ConsumerReport;
};

export const ConsumerItem: React.FC<ConsumerItemProps> = observer(({ data }) => {
  const theme = useTheme();
  return (
    <TableRow>
      {CELLS.map((cell) => (
        <TableCell
          key={cell.name}
          sx={{
            color: cell.coloredText ? theme.palette.error.dark : '',
            fontWeight: cell.fontWeight ? 600 : 'normal',
          }}
        >
          {cell.render ? cell.render(data, cell) : data[cell.name]}
        </TableCell>
      ))}
    </TableRow>
  );
});
